import styled from 'styled-components';
import { Caption01, ProductiveHeading07 } from 'components/styles';

export const VisibilitySubMenuHeading = styled.div`
  ${ProductiveHeading07};
`;

export const VisibilitySubMenuDesc = styled.div`
  ${Caption01};
  margin-bottom: var(--spacing-06);
  color: var(--gray-100);
`;

export const VisibilitySettingsWrapper = styled.div`
  padding: var(--spacing-03) var(--spacing-02);
  white-space: break-spaces;
`;

export const VisibilitySubMenuOption = styled.div`
  display: flex;
  flex-direction: column;
  .visibility-option__info {
    display: none;
  }
`;
